import { useQuery } from "@tanstack/react-query";
import { UserDetailDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_USER_DETAIL = "GET_USER_DETAIL";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetUserDetailRequest {
  userId: string | undefined;
}

const getUserDetail = async (
  params: GetUserDetailRequest,
): Promise<UserDetailDto> => {
  const { userId = "" } = params;

  const response = await usersApi.usersControllerGetUserDetail(userId);

  return response.data;
};

export const useGetUserDetail = (
  user: UserProfileDto | null,
  params: GetUserDetailRequest,
): {
  userDetail?: UserDetailDto;
  userDetailEnabled: boolean;
  isPendingGetUserDetail: boolean;
  isSuccessGetUserDetail: boolean;
} => {
  const enabled = Boolean(params.userId) && roleGuard(user, allowedRoles);
  const { isPending, isSuccess, data } = useQuery({
    queryKey: [DOMAIN_USERS, ACTION_GET_USER_DETAIL],
    queryFn: () => getUserDetail(params),
    enabled,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    userDetail: data,
    userDetailEnabled: enabled,
    isPendingGetUserDetail: isPending,
    isSuccessGetUserDetail: isSuccess,
  };
};
